var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGradientIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 10.0001C12.3018 10.0001 14.1673 8.1346 14.1673 5.83341C14.1673 3.53223 12.3018 1.66675 10.0007 1.66675C7.69946 1.66675 5.83398 3.53223 5.83398 5.83341C5.83398 8.1346 7.69946 10.0001 10.0007 10.0001Z",
    stroke: "url(#paint0_linear_1497_3126)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1585 18.3333C17.1585 15.1083 13.9501 12.5 10.0001 12.5C6.05013 12.5 2.8418 15.1083 2.8418 18.3333",
    stroke: "url(#paint1_linear_1497_3126)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1497_3126",
    x1: 5.27052,
    y1: 8.60675,
    x2: 14.1822,
    y2: 1.67082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1497_3126",
    x1: 1.87376,
    y1: 17.358,
    x2: 7.16223,
    y2: 7.25623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00A4AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGradientIcon);
export default __webpack_public_path__ + "assets/media/user-gradient-icon.910fc631ec16bf8b29f2864ee735ad73.svg";
export { ForwardRef as ReactComponent };